import type { Identity } from '@/types/identity';
import type { IdentityActionKind } from '@/features/IdentityActions';
import { PersonActionModals } from './PersonActionModals';
import { VehicleActionModals } from './VehicleActionModals';

interface ReportIdentityActionModalsProps {
    identity: Identity;
    actionKind: IdentityActionKind;
    onClose: () => void;
    onChanged: () => void;
}

export function ReportIdentityActionModals({
    identity,
    actionKind,
    onClose,
    onChanged,
}: ReportIdentityActionModalsProps) {
    return identity.kind === 'person' ? (
        <PersonActionModals
            entityId={identity.id}
            actionKind={actionKind}
            onClose={onClose}
            onChanged={onChanged}
        />
    ) : (
        <VehicleActionModals
            entityId={identity.id}
            actionKind={actionKind}
            onClose={onClose}
            onChanged={onChanged}
        />
    );
}
